import { render } from "./AOE_EduLicensing.vue?vue&type=template&id=60e6ed66"
import script from "./AOE_EduLicensing.vue?vue&type=script&lang=js"
export * from "./AOE_EduLicensing.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__